
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageSlug]",
      function () {
        return require("private-next-pages/[pageSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageSlug]"])
      });
    }
  